export const environment = {
  version: '1.0',
  production: false,
 /* baseUrl: 'http://192.168.0.104:8080/smpMW/api',
  projectUrl: 'http://192.168.0.104:8080/smpMW/api',
  verionUrl: 'http://192.168.0.104:8080/smpMW/api',
  loginUrl: 'http://192.168.0.104:8080/smpMW/api',
  cors: 'http://192.168.0.104:8080/smpMW/api', */

  baseUrl: 'https://smpdev.patharitech.com/smp_mwdev/api',
  projectUrl: 'https://smpdev.patharitech.com/smp_mwdev/api',
  verionUrl: 'https://smpdev.patharitech.com/smp_mwdev/api',
  loginUrl: 'https://smpdev.patharitech.com/smp_mwdev/api',
  cors: 'https://smpdev.patharitech.com/smp_mwdev/api',
  configUrl: 'https://smpdevconfig.patharitech.com/smp_mwdev/api/config',
  feeUrl:'https://devsmpsuperadmin.patharitech.com/#/open/fee/',

  localCountryId:24,
  env:"dev"
  /*  configUrl: 'http://dev.sarvatrahealth.com/sarvatramwdev/api',
    socketUrl: 'https://dev.sarvatrahealth.com' ,
    pay_key: 'rzp_test_qe2GEzLAHjDUvQ',
    */
};